/**
 * @name MAX_LENGTH
 * @constant
 * @number
 * @description Maximum length a node name is allowed to be
 */
export const MAX_LENGTH = 40;